/**
 * Build IconDrawer item list for NavigationDrawer (runtime + designer preview).
 *
 * @param {object} options
 * @param {Array|null|undefined} options.model - Tab/menu model rows
 * @param {boolean} options.collapsed - When true, chevron shows expand
 * @param {(key: string) => string} options.translate - e.g. Translate('Expand')
 * @param {() => string} options.generateUUID - utils.generateUUID
 * @param {() => void} options.onCollapseToggle - toggles expanded rail width
 * @param {boolean} [options.includeCollapse=true] - append expand/collapse chevron (legacy IconDrawer)
 * @returns {Array<object>}
 */
export function buildNavigationDrawerIconItems({
    model,
    collapsed,
    translate,
    generateUUID,
    onCollapseToggle,
    includeCollapse = true,
}) {
    const items = [];
    if (!model || !Array.isArray(model))
        return items;

    for (let tabi = 0; tabi < model.length; tabi++) {
        const tab = model[tabi];
        if (!tab.$objectid)
            tab.$objectid = generateUUID();
        const placement = tab.location === 'Bottom' ? 'bottom' : 'top';
        let type = 'tab';
        if (tab.kind === 'PopupMenu') type = 'menu';
        else if (tab.kind === 'ActionsOnly') type = 'action';

        const item = {
            id: tabi,
            icon: tab?.Data?.MenuItemData?.Icon?.Icon || tab?.Icon?.Icon || 'mdi-circle-outline',
            tooltip: tab?.Data?.MenuItemData?.Icon?.Tooltip ?? tab?.Data?.MenuItemData?.Title ?? tab?.Icon?.Tooltip ?? tab?.Title ?? '',
            placement,
            type,
            badge: tab.Data?.MenuItemData?.badgecontent,
            rowData: tab,
            controlData: tab.Data?.MenuItemData ?? {},
        };

        if (type === 'menu')
            item.childItems = tab.ChildData ?? [];

        if (type === 'action' && tab.Actions)
            item._navTab = tab;

        items.push(item);
    }

    if (includeCollapse) {
        const firstBottomIndex = items.findIndex((i) => i.placement === 'bottom');
        const collapseItem = {
            id: '__collapse__',
            icon: collapsed ? 'mdi-chevron-double-right' : 'mdi-chevron-double-left',
            tooltip: translate(collapsed ? 'Expand' : 'Collapse'),
            type: 'action',
            placement: 'bottom',
            rowData: null,
            controlData: {},
            _navAction: onCollapseToggle,
        };
        if (firstBottomIndex === -1)
            items.push(collapseItem);
        else
            items.splice(firstBottomIndex, 0, collapseItem);
    }

    return items;
}
